export const columnsOne = [{
  title: 'Completed by',
  dataIndex: 'form_values.b62d',
  key: 'title',
  width: 100,
}, {
  title: 'Activity',
  dataIndex: 'form_values.c769',
  key: 'start',
  width: 100,
}, {
  title: 'Date',
  dataIndex: 'form_values["94d5"]',
  key: 'location',
  width: 100,
}];

export const columnsEquipment = [{
  title: 'Location',
  dataIndex: '0',
  width: 100,
  className: 'DEVTESTLOCATION'
}, {
  title: 'Shaped Charges 3 1/8',
  dataIndex: '1',
  width: 100,
}, {
  title: 'Shaped Charges 2 1/2',
  dataIndex: '2',
  width: 100,
}, {
  title: 'Detcord 80',
  dataIndex: '3',
  width: 100,
}, {
  title: 'Detcord 40',
  dataIndex: '4',
  width: 100,
}, {
  title: 'Detonators',
  dataIndex: '5',
  width: 100,
}];


var sortedInfo = {
  order: 'descend',
  columnKey: 'date',
}
export const columnsEntry = [{
  title: 'Date',
  dataIndex: 'date',
  width: 70,
  render: date => {
    var str = date.split("-");
    var fYear = str[0],
      fMonth = str[1],
      fDay = str[2];

    return fDay + "-" + fMonth + "-" + fYear;
  },
  className: 'hideThis',
  sortOrder: sortedInfo.columnKey === 'age' && sortedInfo.order,
}, {
  title: 'Job Number',
  dataIndex: '0',
  width: 70,
  className: 'hideThis'
}, {
  title: 'Bore Number',
  dataIndex: '1',
  width: 70
}, {
  title: 'Shaped Charges 3 1/8',
  dataIndex: '2',
  width: 100
}, {
  title: 'Shaped Charges 2 1/2',
  dataIndex: '3',
  width: 100
}, {
  title: 'Detcord 80',
  dataIndex: '4',
  width: 100
}, {
  title: 'Detcord 40',
  dataIndex: '5',
  width: 100
}, {
  title: 'Detonators',
  dataIndex: '6',
  width: 100
}, {
  title: 'Perforating Tubes 3 1/8',
  dataIndex: '7',
  width: 100
}, {
  title: 'Perforating Tubes 2 1/5',
  dataIndex: '8',
  width: 100
}];
